<template>
  <div>
    <div @click="dialogVisible=true">
      <slot></slot>
    </div>
    <el-dialog width="340px" title="选择病例" custom-class="take-dialog" :visible.sync="dialogVisible" append-to-body>
      <div v-loading="loading">
        <div class="design-list-warp"  @scroll="listScroll">
          <div class="choose-warp-left-filter" >
            <div class="choose-warp-left-nav" v-if="member.member_type != 1">
              <div :class="case_type == 0 ? 'on' : ''" @click="changeType(0)">咨询病例</div>
              <div :class="case_type == 1 ? 'on' : ''" @click="changeType(1)">管理病例</div>
            </div>
            <div class="choose-warp-left-search d-flex-between">
<!--              <input type="text" placeholder="病例名称或病例编号" v-model="keyWords" @keydown.enter="getList()">-->
              <Input :placeholder="'病例名称或病例编号'" v-model="keyWords" @enter="getList()"/>
              <div class="iconfont icon-sousuo" @click="getList()"></div>
            </div>
          </div>
          <div class="upload-case-item" :class="select_patient.id == item.id ? 'design-list-on' : ''" v-for="item in list" :key="item.id" @click="handleSelect(item)">
            <div class="d-flex-between" style="align-items: center">
              <div class="case-person-name">{{ item.name }}
                <div
                  v-if="item.show_red_dot"
                  class="new-dot"></div>
              </div>
              <div class="case-person-info">{{ item.age_text }}</div>
            </div>
            <div class="case-person-info">{{item.no}}</div>
            <div class="case-person-time-line">
              <div class="case-person-time"><img alt="" src="@/assets/img/doctor-detail/time-shouzhen.png">{{item.sz_date.substring(0, 11)}}
              </div>
              <div v-if="item.new_date" class="case-person-time-split"></div>
              <div v-if="item.new_date" class="case-person-time"><img alt="" src="@/assets/img/doctor-detail/time-zuixin.png">{{item.new_date.substring(0, 11)}}
              </div>
            </div>
            <div class="case-person-cycle package-tag" :class="item.confirm_first_case_type != null ? '' : 'case-person-cycle-grey'">{{item.confirm_first_case_type_text != '' ? item.confirm_first_case_type_text :item.first_case_type_name}}</div>
          </div>
          <div v-if="loadStatus" class="load-info">
            <i v-if="loadStatus == 'load'" class="el-icon-loading"></i>
            <span v-if="loadStatus == 'load'">加载中</span>
            <span v-if="loadStatus == 'over'">已经全部加载完成</span>
          </div>
        </div>
      </div>
      <div class="take-dialog-bottom">
        <div class="take-dialog-close" @click="dialogVisible = false">取消</div>
        <div class="take-dialog-open" @click="handleConfirm">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { search } from "@/http/case";

export default {
  name: "Patient",
  props: {
    doctor_id: {
      type: Number,
      default: null,
    },
    patient_id: {
      type: Number,
      default: null,
    },
  },
  watch: {
    patient_id: {
      handler: function (val, oldVal) {
        if (val != this.select_patient.id) {
          this.select_patient = { id: undefined };
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
      orderBy: ["im_chaosong_at", "desc"],
      list: [],
      select_patient: { id: undefined },
      loading: false,
      case_type:0,
      member:JSON.parse(localStorage.getItem('member')),
      keyWords:'',
      loadStatus:'',
      page: 1
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getList(null,true);
    });
  },
  methods: {
    getList(id,refresh) {
      if(refresh){
        this.page = 1
        this.list = []
        this.loading = true;
      }else if(this.loadStatus === 'over') return
      this.loadStatus = 'load'
      var params = {
        doctor_id: this.doctor_id ? this.doctor_id : this.member.id,
        orderBy: this.orderBy,
        case_type: this.case_type,
        keyWords:this.keyWords,
        page: this.page
      };
      if(id){
        params.doctor_id = id
        this.doctor_id = id
      }

      search(params).then((res) => {

        this.loading = false;
        this.list = this.list.concat(res.data.data);
        this.page += 1
        if(res.data.current_page >= res.data.last_page){
          this.loadStatus = 'over'
        }

      });
    },
    listScroll(event){
      const { scrollTop, clientHeight, scrollHeight } = event.target;

      if (scrollTop + clientHeight >= scrollHeight) {
       this.getList(null,false)
      }
    },
    changeType(val){
      this.case_type = val
      this.getList()
    },
    handleSelect(item) {
      this.select_patient = item;
    },
    handleConfirm() {
      this.emitSelect(this.select_patient);
      this.dialogVisible = false;
    },
    emitSelect(val) {
      this.$emit("update:patient_id", val.id);
      this.$emit("patient", val);
    },
    openDialog(){
      this.dialogVisible = true
      this.keyWords = ''
    }
  },
};
</script>

<style scoped>
.design-list-warp {
  overflow-y: auto;
  max-height: 400px;
  position: relative;
}
.design-list {
  margin-bottom: 5px;
  align-items: center;
  padding: 0 10px;
  cursor: pointer;
  height: 40px;
  border-radius: 8px;
}
.design-list .black-14 {
  font-weight: 500;
}
.design-list .icon-yulan {
  color: #8f8f8f;
}

.upload-case-item {
  width: 288px;
  height: 100px;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  margin-top: 10px;
  background: #ffffff;
  padding: 15px;
  cursor: pointer;
  position: relative;
}
.case-person-name {
  font-size: 17px;
  font-weight: 500;
  color: #000000;
  line-height: 24px;
  display: flex;
  align-items: center;
}
.case-person-info {
  font-size: 14px;
  color: #8f8f8f;
  line-height: 20px;
}
.case-person-info span {
  margin: 0 4px;
}
.case-person-time-line {
  display: flex;
  align-items: center;
  margin-top: 6px;
}
.case-person-time {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #000000;
  white-space: nowrap;
}
.case-person-time img {
  margin-right: 4px;
  width: 27px;
  height: 14px;
}
.case-person-time-split {
  width: 30px;
  height: 1px;
  background: #333333;
  margin: 0 10px;
}
.case-person-state {
  position: absolute;
  right: 0;
  top: 0;
  height: 19px;
  object-fit: contain;
}
.case-person-cycle {
  position: absolute;
  right: 13px;
  top: 40px;
  height: 20px;
  object-fit: contain;
}
.case-person-cycle-grey {
  filter: grayscale(1);
}

.design-list-on {
  border: 1px solid #fed400;
  background: rgba(254, 212, 0, 0.05);
}
.package-tag{
  background: #FFF5C3;
  border: 1px solid #FFED92;
  padding: 0px 5px;
  color: #000;
  font-size: 12px;
  border-radius: 4px;
  font-weight: bold;
  /*font-style: italic;*/
}
.choose-warp-left-filter{
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 2;
  /*padding-bottom: 10px;*/
  background: #ffffff;
}
.choose-warp-left-nav{
  width: 288px;
  display: flex;
  align-items: center;
  height: 28px;
  background: #EEEEEF;
  margin-bottom: 10px;
  border-radius: 9px;
  /*padding: 2px;*/
  /*position: sticky;*/
  /*top: 0;*/
  /*z-index: 2;*/
}
.choose-warp-left-nav div{
  cursor: pointer;
  width: 50%;
  text-align: center;
  line-height: 24px;
  font-size: 13px;
  color: #000000;
  height: 24px;
  border-radius: 7px;
}
.choose-warp-left-nav .on{
  background: #FFFFFF;
  box-shadow: 0px 3px 1px 0px rgba(0,0,0,0.04), 0px 3px 8px 0px rgba(0,0,0,0.12);
  border: 1px solid rgba(0,0,0,0.04);
}
.choose-warp-left-search{
  width: 288px;
  height: 32px;
  padding: 0 10px;
  align-items: center;
  background: #FFFFFF;
  border-radius: 6px;
  border: 1px solid #E8E8E9;
}
.choose-warp-left-search input{
  flex: 1;
}
.choose-warp-left-search div{
  font-size: 20px;
  color: #BDBDBD;
  cursor: pointer;
}
</style>
